import {useQuery} from 'react-query';
import {fetchCompany} from '../../../../requests/queries/flows';
import {UPDATE_COMPANY_INFO} from '../../../../store/types';
import {useDispatch} from 'react-redux';

export const useGatedQuery = (queryKey, queryFn, options = {}) => {
  const authDetails = JSON.parse(localStorage.getItem('state'))?.auth;
  const isGated = authDetails?.userDetails?.company?.id;
  const isGated2 = authDetails?.userDetails?.company?.billing_status;
  const dispatch = useDispatch();

  const {data, isLoading: isLoadingCompany} = useQuery({
    queryKey: ['pr-company-details'],
    queryFn: () => fetchCompany(),
    onSuccess: data => {
      if (data?.entity) {
        const {name, ...rest} = data.entity;
        dispatch({payload: rest, type: UPDATE_COMPANY_INFO});
      }
    },
    enabled: !!isGated && !isGated2,
    retry: false,
    meta: {preventGlobalError: true},
  });

  return useQuery({
    queryKey,
    queryFn: () => {
      if (!isLoadingCompany && !!data) {
        return queryFn();
      }
      return Promise.resolve(null);
    },
    enabled: !isLoadingCompany && !!data,
    ...options,
    onError: err => {
      if (err.response?.data?.error === 'Company does not Exist') {
        // Handle the specific error if needed
        console.warn('Company does not exist.');
        return;
      }

      options.onError(err);
    },
  });
};
